import { useTranslation } from 'react-i18next';

export const useCommonTr = (
  keyPrefix: 'buttons' | 'errors' | 'validation' | 'input' | 'options'
) => useTranslation('common', { keyPrefix });
